class QQLiveConfig {
    constructor() {
        this.inited = false;
    }
    
    init(layout) {
        Object.assign(this, layout);
        
        this.inited = true;
    }
}

let config = new QQLiveConfig()
module.exports = config